<template>
  <ul class="social-list">
    <li class="social-list__item" v-for="(link, index) in links" :key="index">
      <a
        :href="link.href"
        target="_blank"
        class="social-list__link"
        :class="`social-list__link_${link.icon}`"
      >
        <i :class="`icon-${link.icon}`"></i>
      </a>
    </li>
  </ul>
</template>
<script>
export default {
  name: "SocialList",
  data() {
    return {
      links: [
        { icon: "fb", href: "#" },
        { icon: "vk", href: "#" },
        { icon: "twitter", href: "#" },
        { icon: "od", href: "#" },
        { icon: "watch-app", href: "#" },
        { icon: "phone", href: "#" },
        { icon: "telegram", href: "#" }
      ]
    };
  }
};
</script>
